// extracted by mini-css-extract-plugin
module.exports = {"category":"v_","categoryTitle":"wa","stickySearchBoxBar":"wb"};